import Swiper from "swiper";
import { initTimer, clickOn } from "../events/events";

const experts = {
	swipers: [],
	canSwipe: false,
	counter: document.querySelector('#experts .content_part .counter'),
	next(e) {
		if(!this.canSwipe) return
		this.canSwipe = false
		initTimer("experts_swipe", () => {
			this.canSwipe = true
		}, 1300)
		swiper.update()
		e.target.parentElement.querySelector('.prev').classList.add("canPrev")
		if(this.swipers[0].realIndex + 1 < this.swipers[0].slides.length - 1){
			e.target.classList.add("canNext")
		}else{
			e.target.classList.remove("canNext")
		}
		this.swipers.forEach(swiper => {
			swiper.slideNext()
		});

	},
	prev(e) {
		if(!this.canSwipe) return
		this.canSwipe = false
		initTimer("experts_swipe", () => {
			this.canSwipe = true
		}, 1300)
		e.target.parentElement.querySelector('.next').classList.add("canNext")
		if(this.swipers[0].realIndex > 1){
			e.target.classList.add("canPrev")
		}else{
			e.target.classList.remove("canPrev")
		}
		this.swipers.forEach(swiper => {
			swiper.slidePrev()
		});

	},
	updateCounter(){
		this.counter.textContent = `${experts_content?.realIndex + 1} / ${[...this.swipers[0]?.slides].filter(s=>!s.classList.contains('hidden')).length}`;
	},
	setHeight(){
		initTimer(
			"experts",
			() => {
				const index = window.innerWidth < 992 ? 3 : 3;
				if(!this.slides[this.realIndex + index]?.querySelector(".image-thumb")) return
				this.slidesEl.style.height = getComputedStyle(
					this.slides[this.realIndex + index]?.querySelector(".image-thumb")
				)?.height;
			},
			500
		);
	}
}
const experts_content = new Swiper(".experts-content", {
  slidesPerView: 1,
  spaceBetween: 20,
	simulateTouch: false,
  allowTouchMove: false,
  speed: 1300,
  on: {
    init: function () {
			if(!(window.innerWidth < 992)){
				this.slideTo(3);
			}
			if(this.slides.length - 1 > this.realIndex){
				document.querySelector('#experts .content_part .next').classList.add("canNext")
			}
			if(this.realIndex > 0){
				document.querySelector('#experts .content_part .prev').classList.add("canPrev")
			}
			experts.swipers.push(this);
    }
  },
});

const swiper = new Swiper(".experts", {
  slidesPerView: 2,
  spaceBetween: 11,
  speed: 1300,
  simulateTouch: false,
  allowTouchMove: false,
	breakpoints: {
		992: {
			slidesPerView: "auto",
			spaceBetween: 20,
		}
	},
  on: {
    init: function () {
			experts.swipers.push(this);
      experts.setHeight.bind(this)();
			initTimer('canSwipe', () => {
				experts.canSwipe = true
			}, 1500)
			if(!(window.innerWidth < 992)){
				this.slideTo(3);
			}
      experts.updateCounter.bind(experts)();
    },
    slideChange: function () {
      experts.updateCounter.bind(experts)();
    },
    resize: function () {
			experts.setHeight.bind(this)();	
    },
  },
});

clickOn('#experts .content_part .next', experts.next.bind(experts));
clickOn('#experts .content_part .prev', experts.prev.bind(experts));